import { XXL, MD } from "@zendeskgarden/react-typography";
import * as Css from "./style";

export const EmptyState = () => {
  return (
    <Css.Wrapper>
      <Css.Content>
        <XXL isBold>Configuração necessária</XXL>

        <Css.Description as={MD}>
          Este app precisa ser configurado por um administrador do Zendesk antes de ser utilizado.
        </Css.Description>

        <Css.Hint>
          Vá em <b>Admin Center → Apps → Gerenciar → Bulk Ops</b>
          <br />
          e preencha o <b>API Token e E-mail de Admin</b>.
        </Css.Hint>
      </Css.Content>
    </Css.Wrapper>
  );
};
